// AuthProvider.js
import { createContext, useContext } from "react";
import useAuthTokens from "../hooks/useAuthTokens";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const auth = useAuthTokens();
  return (
    <AuthContext.Provider value={auth}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
